/**
 * VoucherBatchesCtrl controller
 * Show all batches
 */

import { remove } from 'app/helpers/entity'
import FileSaver from 'file-saver'
import moment from 'moment'

VoucherBatchesCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * VoucherBatchesCtrl controller
 *
 * @class VoucherBatchesCtrl
 * @memberof mwApp/partners
 * @see mwApp/partners
 *
 * @ngdoc controller
 * @name mwApp/partners.controller:VoucherBatchesCtrl
 */
/* @ngInject */
export default function VoucherBatchesCtrl ($scope, $window, $timeout, $uibModal, $http, authSvc, alertLiteSvc, VoucherBatch, distributor) {
  const vm = this

  vm.isFound = true

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true
  vm.loading = true

  /**
   * Promise stack
   *
   * @type {Array}
   */
  vm.loaderStack = []

  /**
   * Distributor model.
   * @memberof mwApp/partners.controller:VoucherBatchesCtrl
   * @type {Object}
   */
  vm.distributor = distributor

  /**
   * Voucher's Batches list.
   * @memberof mwApp/partners.controller:VoucherBatchesCtrl
   * @name vm.batches
   * @type {Array}
   */

  /**
   * Set isFound to false, if batches is empty.
   */
  const foundAction = () => { vm.isFound = !!vm.batches.length }

  /**
   * Load all batches.
   */
  vm.loaderStack.push(VoucherBatch.loadAll({ $distributor: distributor })
    .to(vm.batches = [])
    .then(
      () => {
        if (vm.firstLoad === undefined) {
          vm.firstLoad = true
        } else if (vm.firstLoad) {
          vm.firstload = false
        }
        vm.batches.forEach(batch => {
          batch.$distributor = distributor
        })
      }
    )
    .then(foundAction))

  /**
   * Load extra of batch.
   */
  if (authSvc.hasAccess('createVoucherBatch')) {
    vm.loaderStack.push(VoucherBatch.loadExtra({ $distributor: distributor })
      .to(vm.extraBatch = {}))
  }

  /**
   * Check loader
   */
  Promise.all(vm.loaderStack)
    .then(() => {
      $scope.loading = false
      vm.loading = false
    })

  /**
   * Delete batch.
   *
   * @memberof mwApp/partners.controller:VoucherBatchesCtrl
   */
  vm.delete = function (batch) {
    batch._delete()
      .then(function () {
        const index = vm.batches.indexOf(batch)

        if (index !== -1) {
          vm.batches[index].progress = 'DELETING'
          $timeout(remove(vm.batches)(batch), 5000)
        }
      })
      .then(foundAction)
  }

  /**
   * Create new voucher
   *
   * @memberof mwApp/partners.controller:VoucherBatchesCtrl
   * @param  {models.Distributor} distributor
   */
  vm.addVoucher = function (distributor) {
    $uibModal.open({
      templateUrl: 'components/partners/views/addVoucherBatch.html',
      controller: 'AddVoucherBatchCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        distributor: () => distributor
      }
    }).result
      .then(batch => vm.batches.push(batch))
      .then(foundAction)
  }

  /**
   * Download file by type
   * @param type
   * @param batch
   */
  vm.export = function (type, batch) {
    let url
    if (type === 'SOLD') {
      url = batch._url + '/export/sold.csv'
    } else {
      url = batch._url + '\\export?format=' + type
    }
    $http.get(url, {
      responseType: 'blob'
    }).then((response) => {
      FileSaver.saveAs(response.data, batch.name + ' ' + moment(batch.createdTime).format('DD-MM-YYYY HH-mm') + '.' + type.toLowerCase())
    })
  }

  /**
   * Generate link to subscribers
   * @param batch
   * @param statuses
   * @returns {string}
   */
  vm.generateLinkSubscribers = function (batch, statuses) {
    let link = 'subscribers'

    if (batch.$distributor.id) {
      link += `?distributor=${batch.$distributor.id}`

      if (statuses && statuses.length) {
        link += `&statuses=${statuses.join(',')}`
      }
    }

    if (batch.$distributor.id && batch.id) {
      link += `&batch=${batch.id}`
    }

    return link
  }

  vm.hasSelectedBatches = function () {
    return vm.batches.some(batch => batch.$selected)
  }

  vm.toggleSelectAll = function () {
    vm.batches
      .forEach(batch => { batch.$selected = batch.pendingVouchersCount && vm.selectAll })
  }

  vm.setExpired = function () {
    const selectedBatchIds = vm.batches.filter(batch => batch.$selected).map(batch => batch.id)

    if (!selectedBatchIds.length) {
      return
    }

    VoucherBatch.expirePending({ distributorId: vm.distributor.id, batchIds: selectedBatchIds })
      .then(() => {
        alertLiteSvc.alert('Subscription status(es) changed from "Pending" to "Expired"', 'success')
        return VoucherBatch.loadAll({ $distributor: vm.distributor })
          .to(vm.batches = [])
          .then(() => {
            vm.batches.forEach(batch => {
              batch.$distributor = vm.distributor
            })
          })
          .then(foundAction)
      })
  }
}
